import React from 'react';
import i18next from 'i18next';
import { Scrollbars } from 'react-custom-scrollbars';
import classNames from 'classnames';
import { connect } from 'react-redux';
import StatusBar from './StatusBar/StatusBar';
import Coupon from './Coupon/Coupon';
import ShortHistory from './ShortHistory/ShortHistory';
import Bets from './Bets/Bets';
import Panel from '../Panel/Panel';
import Chart from './Chart/Chart';
import Spinner from 'react-spinkit';

import Api from '../../api';
import { setBalance } from '../../actions/userActions';
import { crashWs, STATUS_DISCONNECTED } from '../../websocketController';
import { getCf } from '../../utils';
import makeCancelable from '../../api/cancelable';

export const CRASH_STATUS_DISCONNECTED = -2;
export const CRASH_STATUS_LOADING = -1;
export const CRASH_STATUS_BETTING = 0;
export const CRASH_STATUS_IN_GAME = 1;
export const CRASH_STATUS_ENDED = 2;

export const ORDER_STATUS_ACTIVE = 0;
export const ORDER_STATUS_AUTO_STOPPED = 1;
export const ORDER_STATUS_WAIT_FOR_STOP = 2;
export const ORDER_STATUS_MANUAL_STOPPED = 3;

class CrashGame extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      status: CRASH_STATUS_LOADING,
      bets: {},
      history: [],
      placedBet: null,
      loaded: false,
      currentCf: 1,
    };

    this.requests = [];
  }

  componentDidMount() {
    crashWs.sub('crash', this.onDataReceived);

    this.loadOrders();
    this.loadHistory();
  }

  componentWillUnmount() {
    this.requests.forEach((cancel) => cancel());
    crashWs.unsub('crash', this.onDataReceived);
  }

  onDataReceived = (data) => {
    const type = data.type;

    if (type === 'cf') return this.onCfChanged(data);
    if (type === 'order_opened') return this.onOrderOpened(data);
    if (type === 'order_closed') return this.onOrderClosed(data);
    if (type === 'status' && data.status === STATUS_DISCONNECTED) {
      this.setState({ status: CRASH_STATUS_DISCONNECTED });
    }
  };

  onCfChanged = (response) => {
    const data = response.payload;
    const status = +data.current;
    const currentCf = getCf(+data.elapsed);

    if (this.state.status !== status) {
      if (status === CRASH_STATUS_BETTING) this.onBetting(data);
      if (status === CRASH_STATUS_IN_GAME) this.onInGame(data);
      if (status === CRASH_STATUS_ENDED) this.onEnding(data);
    }

    this.setState({ status, currentCf });
  };

  onBetting(data) {
    this.setState({ bets: {}, placedBet: null });
  }

  onInGame() {}

  onEnding() {
    this.updateBalance();
    this.loadHistory();
  }

  onOrderOpened = (response) => {
    const data = response.payload;

    this.setState({
      bets: {
        ...this.state.bets,
        [data.id]: data,
      },
      placedBet: data,
    });
  };

  onOrderClosed = (response) => {
    const data = response.payload;
    const bets = this.state.bets;

    if (!bets[data.id]) {
      return;
    }

    if (data.user_id === this.props.userId) {
      this.setState({
        placedBet: { ...data },
      });
    }

    this.setState({
      bets: {
        ...bets,
        [data.id]: {
          ...bets[data.id],
          ...data,
        },
      },
    });
  };

  updateBalance = () => {
    const { promise, cancel } = makeCancelable(Api.balance());
    this.requests.push(cancel);

    promise.then((response) => {
      this.props.setBalance(response.balance, response.balance_cash);
    });
  };

  loadHistory = () => {
    const { promise, cancel } = makeCancelable(Api.crashHistory());
    this.requests.push(cancel);

    promise.then((response) => {
      if (response.status === 'success') {
        this.setState({
          history: response.data,
        });
      }
    });
  };

  loadOrders = () => {
    const { promise, cancel } = makeCancelable(Api.orders());
    this.requests.push(cancel);

    promise.then((response) => {
      if (
        response.status === 'success' &&
        response.orders &&
        Object.keys(response.orders).length
      ) {
        this.setState({
          bets: response.orders,
        });
      }
    });
  };

  render() {
    const {
      bets = {},
      currentCf,
      status,
      history = [],
      placedBet,
    } = this.state;

    const withColor = [CRASH_STATUS_IN_GAME, CRASH_STATUS_ENDED].includes(
      status
    );

    const gameClasses = classNames(
      'crash-game',
      { disconnected: status === CRASH_STATUS_DISCONNECTED },
      { 'in-game': status === CRASH_STATUS_IN_GAME },
      { betting: status === CRASH_STATUS_BETTING },
      { ended: status === CRASH_STATUS_ENDED },
      { yellow: withColor && currentCf >= 7 },
      { blue: withColor && currentCf >= 1.3 && currentCf < 7 },
      { red: withColor && currentCf < 1.3 }
    );

    return (
      <div className={gameClasses}>
        <Scrollbars style={{ height: '100%' }} hideTracksWhenNotNeeded={true}>
          <div className="crash-game__inner">
            <div className="crash-game__row crash-game__top">
              <Panel
                title={i18next.t('crash.panel_multiplier')}
                className="crash-game__chart"
              >
                <div id="crash-chart">
                  {[CRASH_STATUS_DISCONNECTED, CRASH_STATUS_LOADING].includes(
                    status
                  ) && (
                    <Spinner
                      name="ball-clip-rotate"
                      color="white"
                      fadeIn="quarter"
                    />
                  )}
                  <Chart status={status} />
                </div>
              </Panel>

              <Coupon
                status={status}
                currentCf={currentCf}
                placedBet={placedBet}
                updateBalance={this.updateBalance}
              />
            </div>

            <div className="crash-game__row crash-game__bottom">
              <Panel
                className="crash-game__bets"
                title={i18next.t('crash.panel_bets')}
              >
                <StatusBar status={status} bets={bets} />
                <Bets bets={bets} />
              </Panel>
              <ShortHistory
                history={history}
              />
            </div>
          </div>
          {/*<Footer/>*/}
        </Scrollbars>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      userId: state.user.profile ? state.user.profile.user_id : null,
    };
  },
  {
    setBalance,
  }
)(CrashGame);



// WEBPACK FOOTER //
// ./app/components/CrashGame/CrashGame.jsx